//CreateTonicKnowledge.jsx 


import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Loader from '../../components/utils/Loader';
import useFetch from '../../hooks/useFetch';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBullseye, faClock, faDollarSign, faEarth, faExclamationTriangle, faHeartPulse, faLightbulb, faListCheck, faLock, faMicrochip, faMicrophone, faRobot, faTree, faUserSecret } from '@fortawesome/free-solid-svg-icons';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import validateManyFields from '../../validations';
import '../../styles/Concerns.css';
import '../../styles/Alert.css';
import Tooltip from '../../components/utils/Tooltip';


const CreateTonicKnowledge = () => {
  const authState = useSelector(state => state.authReducer);
  const navigate = useNavigate();
  const [fetchData, { loading }] = useFetch();
  const { tonicId } = useParams();
  const mode = tonicId === undefined ? "add" : "update";
  const [tonicKnowledge, setTonicKnowledge] = useState(null);
  const [showDetailForm, setShowDetailForm] = useState(false);
  const [countFormErrors, setCountFormErrors] = useState(0);
  const [formErrors, setFormErrors] = useState({});
  const [error, setError] = useState(null);
  const [startTime, setStartTime] = useState(false);
  const [endTime, setEndTime] = useState(false);
  const [duration, setDuration] = useState('');
  const [additionalDataEntry, setAdditionalDataEntry] = useState(false);
  const [isFlagged, setIsFlagged] = useState(false);
  const [isUpdateLock, setIsUpdateLock] = useState(false);

  const [formData, setFormData] = useState({
    tonicName: '',
    language: '',
    date: new Date(),
    headline: '',
    brief: '',
    authorName: authState.user.name,
    searchTags: '',
    createdDate: new Date(),
    isActive: true,
    createdBy: authState.user._id,
    creatorName: authState.user.name,
    infoSource: 'NA',
  });
  
  useEffect(() => {
    document.title = mode === "add" ? "Add" : "Update";
  }, [mode]);

  useEffect(() => {
    if (mode === "update") {
      const config = { 
        url: `/tonicknowledge/getforupdate`, 
        method: "post", 
        headers: { Authorization: authState.token }, 
        data: {tonicId: tonicId}
      };
      // console.log("Getting Data for Update here",config);
      // console.log("Existing formData",formData);

      fetchData(config, { showSuccessToast: false })
      .then((data) => {
        // console.log('Response for update:', data.tonicknowledge);
        // setTonicKnowledge(data.tonicKnowledge)
        setFormData({
            tonicName: data.tonicknowledge.tonicName,
            language: data.tonicknowledge.language,
            date: data.tonicknowledge.date,
            headline: data.tonicknowledge.headline,
            brief: data.tonicknowledge.brief,
            authorName: data.tonicknowledge.authorName,
            searchTags: data.tonicknowledge.searchTags,
            createdDate: data.tonicknowledge.createdDate,
            isActive: data.tonicknowledge.isActive,
            createdBy: data.tonicknowledge.createdBy,
            creatorName: data.tonicknowledge.creatorName,
            infoSource: data.tonicknowledge.infoSource,
        });
      })
      .catch((error) => {
        console.error("Error fetching Tonic Knowledge data:", error);
        setError("Error fetching Tonic Knowledge data");
      });
    }
  }, [mode, authState, fetchData, setTonicKnowledge]);

  const handleChange = (e) => {
    setFormData({
      ...formData, [e.target.name]: e.target.value
    });
  };

  const handleStartDateChange = (date) => {
    setFormData(prevFormData => ({
      ...prevFormData,
      startTime: isoDate,
    }));
  };


  const handleSubmit = e => {
    e.preventDefault();
    const error = validateForm(formData);
    // console.log("error : ",error," no. of error",Object.keys(error).length);
    setFormErrors(error);
    setCountFormErrors(Object.keys(error).length);
    // console.log("setFormError : ",setFormErrors);

    if (Object.keys(error).length > 0) {
      setFormErrors(
        Object.keys(error).reduce((total, key) => {
          total[key] = error[key];
          return total;
        }, {})
      );
      return;
    }

    if (mode === "add") {
      const config = { 
        url: "/tonicknowledge", 
        method: "post",
        data: {formData: formData, user: authState.user._id}, 
        headers: { Authorization: authState.token } 
      };
      // console.log("Posting Data ",JSON.stringify(formData, null, 2), " User ",authState.user._id);


      fetchData(config).then(() => {
        navigate("/authordesk-tonicknowledges");
      });
    }
    else {
      const config = { 
        url: `/tonicknowledge/${tonicId}`, 
        method: "put", 
        data: formData, 
        headers: { Authorization: authState.token } 
      };
      // console.log("Posting Data for "+mode+" tonicknowledge: ",config);

      fetchData(config).then(() => {
        navigate("/authordesk-tonicknowledges");
      })
      .catch((error) => {
        console.error("Error updating Tonic Knowledge:", error);
        setError("Error updating Tonic Knowledge");
      });
    }
  }

  const validateForm = formData => {
    const errors = {};
    if (!formData.date) {
      errors.date = "Date is required";
    } 
    if (!formData.tonicName) {
      errors.tonicName = "Tonic Name is required";
    } else if (formData.tonicName.length > 25) {
      errors.tonicName = "Tonic Name  cannot exceed 25 characters";
    }
    if (!formData.headline) {
      errors.headline = "Headline is required";
    } else if (formData.headline.length > 150) {
      errors.headline = "Headline cannot exceed 150 characters";
    }
    if (!formData.brief) {
      errors.brief = "Brief is required";
    } else if (formData.brief.length > 10000) {
      errors.brief = "Text cannot exceed 10000 characters";
    }
    if (!formData.language) {
      errors.language = "Language is required";
    } else if (formData.language.length > 50) {
      errors.language = "Language cannot exceed 50 characters";
    }    
    return errors;
  }

  const fieldError = (field) => (
    <p className={`mt-1 text-pink-600 text-sm ${formErrors[field] ? "block" : "hidden"}`}>
      <i className='mr-2 fa-solid fa-circle-exclamation'></i>
      {formErrors[field]}
    </p>
  )

   const handleDetailFormClick = () => {
    setShowDetailForm(true);
  };

  const handleAddlCheckboxChange = (e) => {
    setAdditionalDataEntry(e.target.checked);
  };


  return (
    <>
      <MainLayout>
        <div className='mt-12'>
          <h3 className='text-lg mx-2 border-b border-b-gray-300 text-white'>Authordesk - Tonic Knowledge Creation</h3>
        </div>
        <div className='m-auto my-2 p-2 border-2 w-full'>
            {loading ? (
              <Loader />
            ) : (
            <div className='text-sm'>
              <div className='flex justify-center'>
                <h2 className="ml-2 text-xl text-yellow-200">{mode === "add" ? "Add New Tonic Knowledge" : "Edit Tonic Knowledge"}</h2>
              </div>
              <div className="border-container-gray ml-8">
                <div className="mb-2 text-sm">
                  <label htmlFor="tonicName">Tonic Name:</label>
                  <br />
                  <input 
                    type="text" 
                    name="tonicName" 
                    id="tonicName" 
                    value={formData.tonicName}
                    onChange={handleChange} 
                    style={{ border: '1px solid #ccc', padding: '8px', width: '100px' }} 
                  />
                  {fieldError("tonicName")}
                </div>
                <div className="mb-2 text-sm">
                  <label htmlFor="date">Publish Date:</label>
                  <br />
                  <DatePicker
                    selected={formData.date}
                    onChange={(date) => setFormData({ ...formData, date: date })}
                    dateFormat="dd/MM/yyyy"
                    id="date"
                    name="date"
                    className="border rounded-md px-1 py-2 w-96 h-12" 
                    placeholderText="Select a date"
                  />
                  {fieldError("date")}
                </div>;
                <div className="mb-2 text-sm">
                  <label htmlFor="headline">Headline:</label>
                  <br />
                  <input 
                    type="text" 
                    name="headline" 
                    id="headline" 
                    value={formData.headline}
                    onChange={handleChange} 
                    style={{ border: '1px solid #ccc', padding: '8px', width: '100%' }} 
                  />
                  {fieldError("headline")}
                </div>
                <div className="mb-2 text-sm">
                  <label htmlFor="brief">Details:</label>
                  <br />
                  <textarea 
                    name="brief" 
                    id="brief" 
                    value={formData.brief}
                    onChange={handleChange}
                    maxLength="10000"
                    style={{ border: '1px solid #ccc', padding: '8px', width: '100%', height: '500px' }} 
                    className='bg-white text-black'
                  />
                  {fieldError("brief")}
                </div>
                <div className="mb-2 text-sm">
                  <label htmlFor="language">Language:</label>
                  <br />
                  <input 
                    type="text" 
                    name="language" 
                    id="language" 
                    value={formData.language}
                    onChange={handleChange} 
                    style={{ border: '1px solid #ccc', padding: '8px', width: '100px' }} 
                  />
                  {fieldError("language")}
                </div>

                <div className="mb-2 text-sm">
                  <label htmlFor="searchTags">Tags:</label>
                  <br />
                  <input 
                    type="text" 
                    name="searchTags" 
                    id="searchTags" 
                    value={formData.searchTags}
                    onChange={handleChange} 
                    style={{ border: '1px solid #ccc', padding: '8px', width: '100%' }} 
                  />
                  {fieldError("searchTags")}
                </div>
                <div className="mb-2 text-sm">
                  <label htmlFor="authorName">Author:</label>
                  <br />
                  <input 
                    type="text" 
                    name="authorName" 
                    id="authorName" 
                    value={formData.authorName}
                    onChange={handleChange} 
                    style={{ border: '1px solid #ccc', padding: '8px', width: '100%' }} 
                  />
                </div>
                <div className="mb-2 text-sm">
                  <label htmlFor="infoSource">Source:</label>
                  <br />
                  <input 
                    type="text" 
                    name="infoSource" 
                    id="infoSource" 
                    value={formData.infoSource}
                    onChange={handleChange} 
                    style={{ border: '1px solid #ccc', padding: '8px', width: '100%' }} 
                  />
                </div>
                <div className="mb-2 text-sm">
                  <label htmlFor="isActive">
                  <br />
                  <input 
                    type="checkbox" 
                    name="isActive" 
                    id="isActive" 
                    checked={formData.isActive === true}
                    onChange={(e) => setFormData({ ...formData, isActive: e.target.checked ? true : false })}
                    className='mr-4'
                    />
                      Is Active
                  </label>
                  {fieldError("isActive")}
                </div>
              </div>
                <div className="border-container flex flex-col justify-center">
                  <div className="flex justify-center">
                    {Object.keys(formErrors).length > 0 && (
                      <div className="form-errors text-red-300 justify-center items-center">
                        {Object.keys(formErrors).map((key) => (
                          <div className="flex justify-center items-center" key={key}>{formErrors[key]}</div>
                        ))}
                      </div>
                    )}
                  </div>
                  <div className="flex justify-center">
                    <button 
                      className='bg-primary text-white px-4 py-2 font-medium hover:bg-primary-dark' 
                      disabled={isUpdateLock && mode==="update"}
                      onClick={handleSubmit}>
                        {mode === "add" ? "Add New" : "Update"}
                    </button>
                    <button 
                      className='ml-4 bg-red-500 text-white px-4 py-2 font-medium' 
                      onClick={() => navigate("/authordesk-tonicknowledges")}>
                        Cancel
                    </button>
                  </div>
                </div>
            </div>
          )}
        </div>
      </MainLayout>
    </>
  )
}

export default CreateTonicKnowledge;